module.exports = __webpack_public_path__ + "img/ly.bea7362c.svg";